/**
 * @file React应用程序的主入口文件
 * @description 负责将App组件渲染到DOM中，是整个React应用的启动点
 * @author 数据管理系统开发团队
 * @date 2024
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';

// 创建根DOM节点
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// 渲染应用程序
root.render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN}>
      <App />
    </ConfigProvider>
  </React.StrictMode>
); 